import { render, staticRenderFns } from "./PatientMain.vue?vue&type=template&id=5e393ea0&scoped=true&"
import script from "./PatientMain.vue?vue&type=script&lang=js&"
export * from "./PatientMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e393ea0",
  null
  
)

export default component.exports